import {
    getFilterRepo, getListRepo, getDetailRepo, PostDetailRepo, putDetailRepo
} from "../repositories/seasonCut-off";
import { createSlice } from "@reduxjs/toolkit";

const SeasonCutOff_Slice = createSlice({
    name: "seasonCutOffReducer",
    initialState: {
        segmentFilterLoading: false,
        segmentFilterData: null,
        segmentFilterError: null,

        duplicateSegmentNameLoading: false,
        duplicateSegmentName: null,
        duplicateSegmentNameError: null,    

        listLoading: false,
        listData: null,
        listError: null,

        interestTypesLoading: false,
        interestTypesData: null,
        interestTypesError: null,

        degreeFilterLoading: false,
        degreeFilterData: null,
        degreeFilterError: null,

        indianCollegestreamLoading: false,
        indianCollegestreamData: null,
        indianCollegestreamError: null,

        levelFilterLoading: false,
        levelFilterData: null,
        levelFilterError: null,

        studyAbroadLoading: false,
        studyAbroadData: null,
        studyAbroadError: null,

        schoolStreamsLoading: false,
        schoolStreamsData: null,
        schoolStreamsError: null,

        certificationStreamsLoading: false,
        certificationStreamsData: null,
        certificationStreamsError: null,

        admissionCounsilLoading: false,
        admissionCounsilData: null,
        admissionCounsilError: null,

        competitionLoading: false,
        competitionData: null,
        competitionError: null,

        getDetailLoading: false,
        getDetailData: null,
        getDetailError: null,

        putDetailLoading: false,
        putDetailData: null,
        putDetailError: null,

        putSyncLoading: false,
        putSyncData: null,
        putSyncError: null,

        postDetailLoading: false,
        postDetailData: null,
        postDetailError: null,

        message:null,
    },
    reducers: {

        getSegmentFilterLoading(state, action) {
            return {
                ...state,
                segmentFilterLoading: true,
            };
        },
        getSegmentFilterSuccess(state, action) {
            return {
                ...state,
                segmentFilterLoading: false,
                segmentFilterData: action.payload,
            };
        },
        getSegmentFilterFailure(state, action) {
            return {
                ...state,
                segmentFilterLoading: false,
                segmentFilterError: action.payload,
            };
        },

        getDuplicateSegmentNameLoading(state, action) {
            return {
                ...state,
                duplicateSegmentNameLoading: true,
            };
        },
        getDuplicateSegmentNameSuccess(state, action) {
            return {
                ...state,
                duplicateSegmentNameLoading: false,
                duplicateSegmentName: action.payload,
            };
        },
        getDuplicateSegmentNameFailure(state, action) {
            return {
                ...state,
                duplicateSegmentNameLoading: false,
                duplicateSegmentNameError: action.payload,
            };
        },

        getListLoading(state, action) {
            return {
                ...state,
                listLoading: true,
            };
        },
        getListSuccess(state, action) {
            return {
                ...state,
                listLoading: false,
                listData: action.payload,
            };
        },
        getListFailure(state, action) {
            return {
                ...state,
                listLoading: false,
                listError: action.payload,
            };
        },

        getInterestTypesLoading(state, actIon) {
            return {
                ...state,
                interestTypesLoading: true,
            };
        },
        getInterestTypesSuccess(state, action) {
            return {
                ...state,
                interestTypesLoading: false,
                interestTypesData: action.payload,
            };
        },
        getInterestTypesFailure(state, action) {
            return {
                ...state,
                interestTypesLoading: false,
                interestTypesError: action.payload,
            };
        },

        getDegreeFilterLoading(state, action) {
            return {
                ...state,
                degreeFilterLoading: true,
            };
        },
        getDegreeFilterSuccess(state, action) {
            return {
                ...state,
                degreeFilterLoading: false,
                degreeFilterData: action.payload,
            };
        },
        getDegreeFilterFailure(state, action) {
            return {
                ...state,
                degreeFilterLoading: false,
                degreeFilterError: action.payload,
            };
        },

        getIndianCollegestreamLoading(state, action) {
            return {
                ...state,
                indianCollegestreamLoading: true,
            };
        },
        getIndianCollegestreamSuccess(state, action) {
            return {
                ...state,
                indianCollegestreamLoading: false,
                indianCollegestreamData: action.payload,
            };
        },
        getIndianCollegestreamFailure(state, action) {
            return {
                ...state,
                indianCollegestreamLoading: false,
                indianCollegestreamError: action.payload,
            };
        },

        getLevelFilterLoading(state, action) {
            return {
                ...state,
                levelFilterLoading: true,
            };
        },
        getLevelFilterSuccess(state, action) {
            return {
                ...state,
                levelFilterLoading: false,
                levelFilterData: action.payload,
            };
        },
        getLevelFilterFailure(state, action) {
            return {
                ...state,
                levelFilterLoading: false,
                levelFilterError: action.payload,
            };
        },

        getStudyAbroadLoading(state, action) {
            return {
                ...state,
                studyAbroadLoading: true,
            };
        },
        getStudyAbroadSuccess(state, action) {
            return {
                ...state,
                studyAbroadLoading: false,
                studyAbroadData: action.payload,
            };
        },
        getStudyAbroadFailure(state, action) {
            return {
                ...state,
                studyAbroadLoading: false,
                studyAbroadError: action.payload,
            };
        },

        getSchoolStreamsLoading(state, action) {
            return {
                ...state,
                schoolStreamsLoading: true,
            };
        },
        getSchoolStreamsSuccess(state, action) {
            return {
                ...state,
                schoolStreamsLoading: false,
                schoolStreamsData: action.payload,
            };
        },
        getSchoolStreamsFailure(state, action) {
            return {
                ...state,
                schoolStreamsLoading: false,
                schoolStreamsError: action.payload,
            };
        },

        getCertificationStreamsLoading(state, action) {
            return {
                ...state,
                certificationStreamsLoading: true,
            };
        },
        getCertificationStreamsSuccess(state, action) {
            return {
                ...state,
                certificationStreamsLoading: false,
                certificationStreamsData: action.payload,
            };
        },
        getCertificationStreamsFailure(state, action) {
            return {
                ...state,
                certificationStreamsLoading: false,
                certificationStreamsError: action.payload,
            };
        },

        getAdmissionCounsilLoading(state, action) {
            return {
                ...state,
                admissionCounsilLoading: true,
            };
        },
        getAdmissionCounsilSuccess(state, action) {
            return {
                ...state,
                admissionCounsilLoading: false,
                admissionCounsilData: action.payload,
            };
        },
        getAdmissionCounsilFailure(state, action) {
            return {
                ...state,
                admissionCounsilLoading: false,
                admissionCounsilError: action.payload,
            };
        },

        getCompetitionLoading(state, action) {
            return {
                ...state,
                competitionLoading: true,
            };
        },
        getCompetitionSuccess(state, action) {
            return {
                ...state,
                competitionLoading: false,
                competitionData: action.payload,
            };
        },
        getCompetitionFailure(state, action) {
            return {
                ...state,
                competitionLoading: false,
                competitionError: action.payload,
                message:action.payload,
            };
        },

        getDetailsLoading(state, action) {
            return {
                ...state,
                getDetailLoading: true,
            };
        },
        getDetailSuccess(state, action) {
            return {
                ...state,
                getDetailLoading: false,
                getDetailData: action.payload,
            };
        },
        getDetailFailure(state, action) {
            return {
                ...state,
                getDetailLoading: false,
                getDetailError: action.payload,
                message:action.payload,
            };
        },

        postDetailsLoading(state, action) {
            return {
                ...state,
                postDetailLoading: true,
            };
        },
        postDetailSuccess(state, action) {
            return {
                ...state,
                postDetailLoading: false,
                postDetailData: action.payload,
                message: "Added Successfully"
            };
        },
        postDetailFailure(state, action) {
            return {
                ...state,
                postDetailLoading: false,
                postDetailError: action.payload,
                message:action.payload,
            };
        },

        putDetailsLoading(state, action) {
            return {
                ...state,
                putDetailLoading: true,
            };
        },
        putDetailSuccess(state, action) {
            return {
                ...state,
                putDetailLoading: false,
                putDetailData: action.payload,
                message: "Updated Successfully"
            };
        },
        putDetailFailure(state, action) {
            return {
                ...state,
                putDetailLoading: false,
                putDetailError: action.payload,
                message:action.payload,
            };
        },

        putSyncLoading(state, action) {
            return {
                ...state,
                putSyncLoading: true,
            };
        },
        putSyncSuccess(state, action) {
            return {
                ...state,
                putSyncLoading: false,
                putSyncData: action.payload,
                message: "LSQ Sync Status Updated Successfully"
            };
        },
        putSyncFailure(state, action) {
            return {
                ...state,
                putSyncLoading: false,
                putSyncError: action.payload,
                message:action.payload,
            };
        },

        clearMessage(state, action) {
            return {
                ...state,
                message:null,
                postDetailError:null,
                putDetailError:null,
                putSyncError:null,
            };
        },

        clearData(state, action) {
            return {
                ...state,
                getDetailData:null,
                postDetailData:null,
                putDetailData:null,
                segmentFilterData:null,
            };
        },

    },
});
export const {

    getSegmentFilterLoading,
    getSegmentFilterSuccess,
    getSegmentFilterFailure,

    getDuplicateSegmentNameLoading,
    getDuplicateSegmentNameSuccess,
    getDuplicateSegmentNameFailure,
    
    getInterestTypesLoading,
    getInterestTypesSuccess,
    getInterestTypesFailure,

    getDegreeFilterLoading,
    getDegreeFilterSuccess,
    getDegreeFilterFailure,


    getIndianCollegestreamLoading,
    getIndianCollegestreamSuccess,
    getIndianCollegestreamFailure,

    getLevelFilterLoading,
    getLevelFilterSuccess,
    getLevelFilterFailure,

    getStudyAbroadLoading,
    getStudyAbroadSuccess,
    getStudyAbroadFailure,

    getSchoolStreamsLoading,
    getSchoolStreamsSuccess,
    getSchoolStreamsFailure,

    getCertificationStreamsLoading,
    getCertificationStreamsSuccess,
    getCertificationStreamsFailure,

    getAdmissionCounsilLoading,
    getAdmissionCounsilSuccess,
    getAdmissionCounsilFailure,

    getCompetitionLoading,
    getCompetitionSuccess,
    getCompetitionFailure,

    getListLoading,
    getListSuccess,
    getListFailure,

    getDetailsLoading,
    getDetailSuccess,
    getDetailFailure,

    postDetailsLoading,
    postDetailSuccess,
    postDetailFailure,

    putDetailsLoading,
    putDetailSuccess,
    putDetailFailure,

    putSyncLoading,
    putSyncSuccess,
    putSyncFailure,

    clearMessage,
    clearData,

} = SeasonCutOff_Slice.actions;

export const getSegmentFilter = (params) => {
    return async (dispatch) => {
        dispatch(getSegmentFilterLoading());
        await getListRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getSegmentFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getSegmentFilterFailure(error.message));
                }
            });
    };
};

export const getDuplicateSegmentName = (params) => {
    return async (dispatch) => {
        dispatch(getDuplicateSegmentNameLoading());
        await getListRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getDuplicateSegmentNameSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDuplicateSegmentNameFailure(error.message));
                }
            });
    };
};

export const getList = (params) => {
    return async (dispatch) => {
        dispatch(getListLoading());
        await getListRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getListFailure(error.message));
                }
            });
    };
};

export const getInterestTypesFilter = (params) => {
    return async (dispatch) => {
        dispatch(getInterestTypesLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getInterestTypesSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getInterestTypesFailure(error.message));
                }
            });
    };
};

export const getDegreeFilter = (params) => {
    return async (dispatch) => {
        dispatch(getDegreeFilterLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getDegreeFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDegreeFilterFailure(error.message));
                }
            });
    };
};

export const getIndianCollegestreamFilter = (params) => {
    return async (dispatch) => {
        dispatch(getIndianCollegestreamLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getIndianCollegestreamSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getIndianCollegestreamFailure(error.message));
                }
            });
    };
};

export const getLevelFilter = (params) => {
    return async (dispatch) => {
        dispatch(getLevelFilterLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getLevelFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getLevelFilterFailure(error.message));
                }
            });
    };
};

export const getStudyAbroadFilter = (params) => {
    return async (dispatch) => {
        dispatch(getStudyAbroadLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getStudyAbroadSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getStudyAbroadFailure(error.message));
                }
            });
    };
};

export const getSchoolStreamsFilter = (params) => {
    return async (dispatch) => {
        dispatch(getSchoolStreamsLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getSchoolStreamsSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getSchoolStreamsFailure(error.message));
                }
            });
    };
};

export const getCertificationStreamsFilter = (params) => {
    return async (dispatch) => {
        dispatch(getCertificationStreamsLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getCertificationStreamsSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCertificationStreamsFailure(error.message));
                }
            });
    };
};

export const getAdmissionCounsilFilter = (params) => {
    return async (dispatch) => {
        dispatch(getAdmissionCounsilLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getAdmissionCounsilSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getAdmissionCounsilFailure(error.message));
                }
            });
    };
};

export const getCompetitionFilter = (id) => {
    return async (dispatch) => {
        dispatch(getCompetitionLoading());
        await getDetailRepo(id)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getCompetitionSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getCompetitionFailure(error.message));
                }
            });
    };
};

export const getDetailsData = (id) => {
    return async (dispatch) => {
        dispatch(getDetailsLoading());
        await getDetailRepo(id)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDetailFailure(error.message));
                }
            });
    };
};

export const postMappingDetail = (id) => {
    return async (dispatch) => {
        dispatch(postDetailsLoading());
        await PostDetailRepo(id)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(postDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postDetailFailure(error.response?.data?.message));
                }
            });
    };
};

export const putMappingDetail = (params, id) => {
    return async (dispatch) => {
      dispatch(putDetailsLoading());
      await putDetailRepo(params, id)
        .then((response) => {
          if (response?.status >= 200 && response?.status < 300) {
            dispatch(putDetailSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(putDetailFailure(error.response?.data?.message));
          }
        });
    };
};
export const updateUserSegmentSync = (params, id) => {
    return async (dispatch) => {
      dispatch(putSyncLoading());
      await putDetailRepo(params, id)
        .then((response) => {
          if (response?.status >= 200 && response?.status < 300) {
            dispatch(putSyncSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(putSyncFailure(error.response?.data?.message));
          }
        });
    };
};

export default SeasonCutOff_Slice.reducer;